export default __webpack_public_path__ + "static/media/IpHomeOn.03630ca8.svg";